import React, { useEffect, useState } from 'react';
import { Loader2, Save } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

export const VendorResponseDialog = ({ rfq, open, onOpenChange, onSave, saving }) => {
  const [currency, setCurrency] = useState('INR');
  const [priceBasis, setPriceBasis] = useState('per_piece');
  const [exchangeRate, setExchangeRate] = useState('');
  const [reference, setReference] = useState('');
  const [remarks, setRemarks] = useState('');
  const [prices, setPrices] = useState({});

  useEffect(() => {
    if (rfq) {
      setPrices(Object.fromEntries((rfq.items || []).map((item) => [item.inquiry_product_id, ''])));
      setCurrency((rfq.currency || 'INR').toUpperCase());
      setPriceBasis(rfq.price_basis || 'per_piece');
    }
  }, [rfq]);

  if (!rfq) return null;
  const payload = () => ({
    currency, price_basis: priceBasis, exchange_rate: exchangeRate ? Number(exchangeRate) : null,
    quote_reference: reference || null, remarks: remarks || null,
    items: rfq.items.map((item) => ({ inquiry_product_id: item.inquiry_product_id, unit_price: Number(prices[item.inquiry_product_id] || 0) })),
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}><DialogContent className="max-w-3xl" data-testid="vendor-response-dialog">
      <DialogHeader><DialogTitle>Record vendor pricing</DialogTitle><DialogDescription>{rfq.vendor_name} · {rfq.rfq_number}</DialogDescription></DialogHeader>
      <div className="grid gap-4 py-3 md:grid-cols-4">
        <div className="space-y-2"><Label>Vendor quote reference</Label><Input value={reference} onChange={(event) => setReference(event.target.value)} data-testid="vendor-response-reference-input" /></div>
        <div className="space-y-2"><Label>Currency</Label><Input value={currency} onChange={(event) => setCurrency(event.target.value.toUpperCase())} data-testid="vendor-response-currency-input" /></div>
        <div className="space-y-2"><Label>Price basis</Label>
          <select className="h-10 w-full border bg-white px-2 text-sm" value={priceBasis}
            onChange={(event) => setPriceBasis(event.target.value)} data-testid="vendor-response-basis-select">
            <option value="per_piece">per piece</option>
            <option value="per_100">per 100 pcs</option>
            <option value="per_1000">per 1000 pcs</option>
          </select>
        </div>
        <div className="space-y-2"><Label>Exchange rate to INR</Label>
          <Input type="number" step="0.0001" value={exchangeRate} disabled={currency === 'INR'} placeholder={currency === 'INR' ? 'Not needed' : 'e.g. 86.5'}
            onChange={(event) => setExchangeRate(event.target.value)} data-testid="vendor-response-exchange-rate-input" /></div>
      </div>
      <div className="max-h-[300px] space-y-2 overflow-y-auto">{rfq.items.map((item) => (
        <div key={item.inquiry_product_id} className="grid gap-3 border p-3 md:grid-cols-[1fr_160px]">
          <div><p className="font-mono text-sm">{item.part_number || '—'}</p><p className="text-sm text-muted-foreground">{item.description}</p></div>
          <div><Label>Unit price</Label><Input type="number" step="0.0001" value={prices[item.inquiry_product_id] || ''}
            onChange={(event) => setPrices({ ...prices, [item.inquiry_product_id]: event.target.value })} data-testid={`vendor-response-price-${item.inquiry_product_id}`} /></div>
        </div>
      ))}</div>
      <div className="space-y-2"><Label>Remarks</Label><Textarea value={remarks} onChange={(event) => setRemarks(event.target.value)} data-testid="vendor-response-remarks-input" /></div>
      <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)} data-testid="vendor-response-cancel-button">Cancel</Button>
        <Button onClick={() => onSave(payload())} disabled={saving || Object.values(prices).some((value) => value === '')} data-testid="vendor-response-save-button">
          {saving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Save className="mr-2 h-4 w-4" />} Save pricing
        </Button></DialogFooter>
    </DialogContent></Dialog>
  );
};